import { render } from "./pl35-shi.vue?vue&type=template&id=b63d508e&scoped=true"
import script from "./pl35-shi.vue?vue&type=script&lang=js"
export * from "./pl35-shi.vue?vue&type=script&lang=js"

import "./pl35-shi.vue?vue&type=style&index=0&id=b63d508e&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b63d508e"]])

export default __exports__